import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';

import Outcome from 'newDesign/modules/live/components/bettingSuggestions/Outcome';
import { isMarketInCollection } from 'reducers/fishnetHelpers';
import { overUnderMarketsUOF } from 'constants/enum';

import {
  getSwapOverUnder,
} from 'reducers';

const getOutcomeKey = outcome => (outcome && outcome.tbid) || null;

const Market = cssModule(({ marketName, outcomes, swapOverUnder }) => {
  if (!marketName || !(outcomes && outcomes.length)) return null;

  const marketNameUnified = String(marketName).replace(/\s+/g, '').toLowerCase();
  const marketNameLetters = marketNameUnified === '1x2'
    ? ['1', 'x', '2']
    : marketNameUnified === '12'
      ? ['1', '2']
      : null;

  const useSplitMarketName = marketNameLetters && marketNameLetters.length === outcomes.length;

  const outcomesWithKeys = useMemo(
    () => (outcomes || [])
      .map(outcome => ({ outcome, key: getOutcomeKey(outcome) }))
      .filter(x => Boolean(x.key)),
    [outcomes],
  );

  const isOverUnderMarket = isMarketInCollection(overUnderMarketsUOF, outcomes[0].marketId);
  let outcomeComps = null;

  outcomeComps = outcomesWithKeys.map(({ outcome, key }) => (
    <Outcome
      key={key}
      outcome={outcome}
    />
  ));

  if (isOverUnderMarket && swapOverUnder) {
    outcomeComps = outcomeComps.reverse(); // swap over under outcomes
  }

  return (
    <div>
      {useSplitMarketName ? (
        <div className='grid auto-cols-fr grid-flow-col gap-[2vw] uppercase fs-18 font-second--medium text-white'>
          {marketNameLetters.map((character, i) => (
            <div key={i} className='text-center'>{character}</div>
          ))}
        </div>
      ) : (
        <div className='uppercase fs-18 font-second--medium text-white'>
          {marketName}
        </div>
      )}

      <div className='mx-auto mt-[0.5vw] mb-[0.5vw] h-[0.08vw] w-[90%] bg-white/25' />

      <div className='grid auto-cols-fr grid-flow-col gap-[2vw]'>
        {outcomeComps}
      </div>
    </div>
  );
});

const mapStateToProps = state => ({
  swapOverUnder: getSwapOverUnder(state),
});

Market.propTypes = {
  outcomes: PropTypes.array,
  marketName: PropTypes.string,
};

Market.defaultProps = {
  outcomes: null,
  marketName: '',
};

export default connect(mapStateToProps)(Market);
